import * as z from "zod/v4";

export const getShipedgeIntegration = {
  name: "getShipedgeIntegration" as const,
  input: z.object({}),
  output: z.object({
    shipedgeIntegration: z.optional(
      z.object({
        enabled: z.boolean(),
        apiKey: z.string(),
        accountId: z.string(),
        integrationHost: z.string(),
        warehouse: z.string(),
      }),
    ),
  }),
};

export type GetShipedgeIntegrationOutput = z.infer<
  typeof getShipedgeIntegration.output
>;

export const putShipedgeIntegration = {
  name: "putShipedgeIntegration" as const,
  input: z.object({
    enabled: z.boolean(),
    apiKey: z.string().optional(),
    accountId: z.string(),
    integrationHost: z.string(),
    warehouse: z.string(),
  }),
  output: z.object({}),
};

export type PutShipedgeIntegrationInput = z.infer<
  typeof putShipedgeIntegration.input
>;

export const disconnectShipedgeIntegration = {
  name: "disconnectShipedgeIntegration" as const,
  input: z.object({}),
  output: z.object({}),
};
